// extracted by mini-css-extract-plugin
export default {"header":"Header__header___vsqi0"};